import React from 'react';

import { useIntl } from 'react-intl';

import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { queryClient } from 'src/lib/react-query';
import { toast } from 'src/hooks/useToast';
import { MoneyAccount } from 'src/features/moneyAccounts/utils/types';
import { LIST_MONEY_ACCOUNTS_RESOURCE } from 'src/features/moneyAccounts/api/useListMoneyAccounts';
import { useUpdateMoneyAccount } from 'src/features/moneyAccounts/api/useUpdateMoneyAccount';
import MoneyAccountFormModal from 'src/features/moneyAccounts/components/forms/MoneyAccountFormModal';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';

interface UpdateMoneyAccountFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedMoneyAccount: MoneyAccount;
    children?: React.ReactNode;
}

function UpdateMoneyAccountFormModal<TData>({
                                                   className,
                                                   semantics,
                                                   children,
                                                   selectedMoneyAccount,
                                               }: UpdateMoneyAccountFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useUpdateMoneyAccount({
        onSuccess: ({ name }) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_MONEY_ACCOUNTS_RESOURCE] });
            toast({
                title: formatMessage(moneyAccountsMessages.updateMoneyAccountSuccess),
                description: formatMessage(moneyAccountsMessages.updateMoneyAccountSuccessDescription, {
                    entity: name,
                }),
            });
        },
    });

    return (
        <MoneyAccountFormModal
            selectedMoneyAccount={selectedMoneyAccount}
            className={className}
            mutate={(values, onSuccess, onError) =>
                mutate({ ...values, id: selectedMoneyAccount.id }, { onSuccess, onError })
            }
            title={formatMessage(generalMessages.editEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.EDIT}
            isPending={isPending}
            subtitle={formatMessage(moneyAccountsMessages.editMoneyAccountSubtitle, {
                entity: selectedMoneyAccount.name,
            })}
        >
            {children}
        </MoneyAccountFormModal>
    );
}

export default UpdateMoneyAccountFormModal;
